import { render, staticRenderFns } from "./nationSelect.vue?vue&type=template&id=9b90204a&"
import script from "./nationSelect.vue?vue&type=script&lang=ts&"
export * from "./nationSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports